import React, { Component } from 'react'
import {
    Card, CardHeader, CardImg, CardBody, CardText, Button, Row, Col
} from 'reactstrap'
import { Link } from 'react-router-dom'
import './productItem.css'
import Share from '../facebook/share';
import { animations } from 'react-animation'

export default class ProductItem extends Component {
    render() {
        return (
            <Card className="itemProducto" style={{ animation: animations.popIn }} >
                <CardHeader>{this.props.product.data().Descripcion}</CardHeader>
                {
                    this.props.product.data().Img &&
                    <CardImg top width="100%" src={this.props.product.data().Img} alt="Card image cap" />
                }
                <CardBody>
                    {/* <CardTitle>Special Title Treatment</CardTitle> */}
                    <CardText>{this.props.product.data().Detalle}</CardText>
                    {/* <Button className="btn-rojo">Ver más</Button>   */}
                    <Row>
                        <Col>
                            <Link className="btn btn-rojo btn-sm" to={`/producto/${this.props.product.id}`}>Ver más</Link>{' '}
                            <Share url={`${window.location.hostname}/producto/${this.props.product.id}`} />{' '}
                        </Col>
                    </Row>

                    <Row className="rowEditarEliminar">
                        <Col>
                            {
                                this.props.productoEditar &&
                                <Link className="btn btn-rojo btn-sm btn-block" to={`/admin/productos/editar/${this.props.product.id}`}>Editar</Link>
                            }
                        </Col>
                        <Col>
                            {
                                this.props.productoEliminar &&
                                <Button className="btn btn-sm" color="dark" onClick={this.props.productoEliminar} id={this.props.product.id} name={this.props.product.data().Descripcion} block>Eliminar</Button>
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        )
    }
}